<template>
  <v-container class="mb-0 pb-0">
    <v-row>
      <v-col class="col-2"></v-col>
      <v-col class="col-4 pa-0">
        <IncidentsCategoryToggleButton
          style="margin: auto;"
          type="security"
          :selected="localSelectedPolitical"
          @click="handleToggleClick('security')"
        ></IncidentsCategoryToggleButton>
      </v-col>
      <v-col class="col-4 pa-0">
        <IncidentsCategoryToggleButton
          style="margin: auto;"
          type="maritime"
          :selected="localSelectedMaritime"
          @click="handleToggleClick('maritime')"
        ></IncidentsCategoryToggleButton>
      </v-col>
      <v-col class="col-2"></v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="mt-4 mb-0 pb-0">
        <h4
          :class="{ 'hyp-disabled-text': disabled }"
          class="hyp-category-text"
        >
          By Category
        </h4>
        <div>
          <v-select
            :disabled="disabled"
            class="hyp-dropdown"
            v-model="localCategories"
            :items="categories"
            item-text="Name"
            item-value="Id"
            :menu-props="{ maxHeight: '400' }"
            :clearable="true"
            :chips="true"
            :small-chips="true"
            deletable-chips
            multiple
          >
            <template v-if="selectedMaritime" v-slot:prepend-item>
              <v-text-field
                class="pl-5 pr-5"
                label="Search"
                v-model="search"
              ></v-text-field>
            </template>
          </v-select>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import lodashIsEqual from "lodash/isEqual";

import POLITICAL_CATEGORIES from "@/common/constants/controlRisks/IncidentsPoliticalCategories.js";
import MARITIME_CATEGORIES from "@/common/constants/controlRisks/IncidentsMaritimeCategories.js";
import { mapGetters } from "vuex";
import { MODULE_PREFIX_MAP } from "@/store";

const EMITTED_ACTIONS = {
  CLEAR_SECTORS: "clear-sectors",
  CHANGE_CATEGORIES: "change-categories",
  CHANGE_POLITICAL: "change-political",
  CHANGE_MARITIME: "change-maritime",
};

export default {
  name: "IncidentsCategoryToggles",
  components: {
    IncidentsCategoryToggleButton: () =>
      import(
        "@/components/controlRisks/incidents/IncidentsCategoryToggleButton"
      ),
  },
  props: {
    selectedPolitical: {
      type: Boolean,
      default: false,
    },
    selectedMaritime: {
      type: Boolean,
      default: false,
    },
    selectedCategories: {
      type: Array,
    },
  },
  data() {
    return {
      localCategories: [],
      localSectors: [],
      search: "",
      localSelectedPolitical: false,
      localSelectedMaritime: false,
    };
  },
  computed: {
    ...mapGetters({
      resetMapIcons: MODULE_PREFIX_MAP + "resetMapIcons",
    }),
    categories() {
      return this.localSelectedPolitical
        ? this.categoriesPolitical
        : this.categoriesMaritime;
    },
    categoriesPolitical() {
      return POLITICAL_CATEGORIES;
    },
    categoriesMaritime() {
      return MARITIME_CATEGORIES.filter((item) => {
        return (
          item.Name.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
          this.search === ""
        );
      }).sort(function (a, b) {
        var nameA = a.Name.toLowerCase();
        var nameB = b.Name.toLowerCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    },
    categoriesLabel() {
      return this.selectedPolitical
        ? "Political Categories"
        : "Maritime Categories";
    },
    disabled() {
      return !this.selectedPolitical && !this.selectedMaritime;
    },
  },
  mounted() {
    this.localCategories = this.selectedCategories;
    this.localSelectedPolitical = this.selectedPolitical;
    this.localSelectedMaritime = this.selectedMaritime;
  },
  methods: {
    handleToggleClick(type) {
      this.localCategories = [];
      if (type === "security") {
        this.localSelectedPolitical = !this.localSelectedPolitical;
        this.localSelectedMaritime = false;
      } else if (type === "maritime") {
        this.localSelectedPolitical = false;
        this.localSelectedMaritime = !this.localSelectedMaritime;
      }
    },
    hasPoliticalCategories() {
      return (
        this.localCategories.filter((item) => {
          for (let i = 0; i < POLITICAL_CATEGORIES.length; i++) {
            if (item === POLITICAL_CATEGORIES[i].Id) {
              return true;
            }
          }
          return false;
        }).length > 0
      );
    },
    hasMaritimeCategories() {
      return (
        this.localCategories.filter((item) => {
          for (let i = 0; i < MARITIME_CATEGORIES.length; i++) {
            if (item === MARITIME_CATEGORIES[i].Id) {
              return true;
            }
          }
          return false;
        }).length > 0
      );
    },
  },
  watch: {
    localCategories: {
      handler(newVal, oldVal) {
        if (!lodashIsEqual(newVal, oldVal)) {
          this.$emit(EMITTED_ACTIONS.CHANGE_CATEGORIES, this.localCategories);
        }
      },
    },
    localSelectedPolitical: {
      handler(newVal, oldVal) {
        if (!lodashIsEqual(newVal, oldVal)) {
          this.$emit(
            EMITTED_ACTIONS.CHANGE_POLITICAL,
            this.localSelectedPolitical
          );
        }
      },
    },
    localSelectedMaritime: {
      handler(newVal, oldVal) {
        if (!lodashIsEqual(newVal, oldVal)) {
          this.$emit(
            EMITTED_ACTIONS.CHANGE_MARITIME,
            this.localSelectedMaritime
          );
        }
      },
    },
    resetMapIcons: {
      handler(newValue, oldValue) {
        if (oldValue !== newValue) {
          this.localSelectedPolitical = false;
          this.$emit(EMITTED_ACTIONS.CHANGE_CATEGORIES, []);
          this.$emit(EMITTED_ACTIONS.CHANGE_POLITICAL, false);
          this.$emit(EMITTED_ACTIONS.CHANGE_MARITIME, false);
        }
      },
    },
  },
};
</script>

<style>
.hyp-dropdown {
  padding-top: 0;
  margin-top: 0;
}
.hyp-dropdown .v-text-field__details {
  display: none !important;
}
.hyp-dropdown .v-input__slot {
  margin-bottom: 0 !important;
}
.hyp-category-text {
  margin-left: -12px;
}
.hyp-disabled-text {
  color: gray;
}
</style>
